import { render, staticRenderFns } from "./ServiceListManage.vue?vue&type=template&id=6a2bf641&scoped=true"
import script from "./ServiceListManage.vue?vue&type=script&lang=js"
export * from "./ServiceListManage.vue?vue&type=script&lang=js"
import style0 from "./ServiceListManage.vue?vue&type=style&index=0&id=6a2bf641&prod&lang=css"
import style1 from "./ServiceListManage.vue?vue&type=style&index=1&id=6a2bf641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2bf641",
  null
  
)

export default component.exports